import { AuthConfig } from 'angular-oauth2-oidc';

export const authConfig: AuthConfig = {
  // Login Url
  loginUrl: '',
  // The SPA's id. The SPA is registerd with this id at the auth-server
  clientId: '',
  // OAuth2 setup
  // URL of the SPA to redirect the user to after login
  redirectUri: '',
  // Issuer Url / Uri
  issuer: '',
  // Token endpoint
  tokenEndpoint: '',
  // User info endpoint uri
  userinfoEndpoint: '',

  requireHttps: false,
  showDebugInformation: true,

  useSilentRefresh: true,
  silentRefreshRedirectUri: '',

  // set to true, to receive also an id_token via OpenId Connect (OIDC) in addition to the
  // OAuth2-based access_token
  oidc: true,
  // set the scope for the permissions the client should request
  // The first three are defined by OIDC. The 4th is a usecase-specific one
  scope: 'openid',
  responseType: 'code',
  clearHashAfterLogin: true
};
